import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/api';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: '', password_confirmation: '' });
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const token = params.get('token') || '';

  const submit = async event => {
    event.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      await authService.resetPassword({ token, ...form });
      setMessage('Senha alterada com sucesso. Você já pode entrar.');
      setTimeout(() => navigate('/login'), 1200);
    } catch (err) {
      setError(err.response?.data?.error || 'Não foi possível redefinir a senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.container}>
      <form style={s.card} onSubmit={submit}>
        <img src="/logo.png" alt="Arena Cyber Café" style={s.logo} />
        <h1 style={s.title}>Redefinir senha</h1>
        {!token && <div style={s.error}>Link inválido. Solicite uma nova recuperação.</div>}
        {error && <div style={s.error}>{error}</div>}
        {message && <div style={s.success}>{message}</div>}
        <label style={s.field}>Nova senha
          <Password value={form.password} show={show} toggle={() => setShow(!show)} onChange={e => setForm({ ...form, password: e.target.value })} />
        </label>
        <label style={s.field}>Confirmar nova senha
          <Password value={form.password_confirmation} show={show} toggle={() => setShow(!show)} onChange={e => setForm({ ...form, password_confirmation: e.target.value })} />
        </label>
        <button style={s.btn} disabled={loading || !token}>{loading ? 'Salvando...' : 'SALVAR NOVA SENHA'}</button>
        <button type="button" style={s.back} onClick={() => navigate('/login')}>Voltar para login</button>
      </form>
    </div>
  );
}

function Password({ value, onChange, show, toggle }) {
  return <div style={s.passwordWrap}><input style={{ ...s.input, paddingRight: 44 }} type={show ? 'text' : 'password'} value={value} onChange={onChange} minLength={6} required /><button type="button" style={s.eyeBtn} onClick={toggle}>{show ? '🙈' : '👁️'}</button></div>;
}

const s = {
  container: { minHeight: '100vh', padding: 16, boxSizing: 'border-box', background: 'radial-gradient(circle at 50% 25%, #14210a 0%, #0a0a0f 60%)', display: 'grid', placeItems: 'center', fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' },
  card: { width: 390, maxWidth: '92vw', background: '#14141f', border: '1px solid #262636', borderRadius: 16, padding: 32, boxSizing: 'border-box', boxShadow: '0 20px 60px rgba(0,0,0,.5)' },
  logo: { display: 'block', width: 210, maxWidth: '80%', margin: '0 auto 12px' },
  title: { color: '#fff', textAlign: 'center', fontSize: 22, margin: '0 0 20px' },
  field: { display: 'block', color: '#9ca3af', fontSize: 13, fontWeight: 700, marginBottom: 14 },
  input: { width: '100%', marginTop: 6, padding: '10px 12px', boxSizing: 'border-box', background: '#262636', border: '1px solid #374151', borderRadius: 8, color: '#fff', fontSize: 14, outline: 'none' },
  passwordWrap: { position: 'relative' },
  eyeBtn: { position: 'absolute', right: 6, top: 12, width: 32, height: 30, border: 0, borderRadius: 7, background: '#1a1a28', color: '#fff', cursor: 'pointer' },
  btn: { width: '100%', padding: 12, marginTop: 8, background: 'linear-gradient(135deg, var(--accent), #65a30d)', border: 0, borderRadius: 8, color: '#0a0a0f', fontSize: 14, fontWeight: 900, cursor: 'pointer' },
  back: { width: '100%', padding: 11, marginTop: 12, background: 'transparent', border: '1px solid var(--accent)', borderRadius: 8, color: 'var(--accent)', fontSize: 13, fontWeight: 700, cursor: 'pointer' },
  error: { background: '#450a0a', border: '1px solid #7f1d1d', color: '#fca5a5', borderRadius: 8, padding: '10px 12px', marginBottom: 14, fontSize: 13 },
  success: { background: '#10230a', border: '1px solid #3f6212', color: '#d9f99d', borderRadius: 8, padding: '10px 12px', marginBottom: 14, fontSize: 13 },
};
